<template>
  <div>
    <h1 class="title is-size-4-mobile">{{ $t("Scheduler settings") }}</h1>
    <field-horizontal-table :label="$t('Time intervals')" class="hours-table">
      <hours-row
        v-for="(hour, idx) in hours"
        :key="hour.id"
        :hour="hour"
        :showUp="hour.id && idx > 0"
        :showDown="hour.id && idx < hours.length - 2"
        :failureMsg="changeFailureMsg[hour.id]"
        :successMsg="changeSuccessMsg[hour.id]"
        @saveHour="saveHour"
        @deleteHour="deleteHour(hour.id)"
        @moveUp="swapHours(hours[idx - 1], hours[idx])"
        @moveDown="swapHours(hours[idx], hours[idx + 1])"
      />
    </field-horizontal-table>
  </div>
</template>

<script>
import { state, actions } from "@/store"
import { resetTimeout } from "@/utils"
import { FieldHorizontalTable } from "@/components/form"
import HoursRow from "@/components/settings/hours-row"

const MSG_TIMEOUT_MS = 3000

export default {
  name: "scheduler-settings",
  components: {
    FieldHorizontalTable,
    HoursRow
  },
  data() {
    return {
      changeSuccessMsg: {},
      changeFailureMsg: {}
    }
  },
  computed: {
    hours() {
      const hours = Object.values(state.project.data.schedulingConf.hours || {})
      hours.push({
        order: hours[hours.length - 1] ? hours[hours.length - 1].order + 1 : 0,
        schedule: {}
      })
      return hours
    }
  },
  methods: {
    saveHour(hour) {
      this.changeFailureMsg = {}
      this.changeSuccessMsg = {}
      actions
        .saveSchedulingConfHour(hour)
        .then(hour => {
          this.$set(this.changeSuccessMsg, hour.id, "Saved")
          resetTimeout(
            `setHours_${hour.id}`,
            () => (this.changeSuccessMsg[hour.id] = undefined),
            MSG_TIMEOUT_MS
          )
        })
        .catch(e => {
          this.changeFailureMsg[hour.id] =
            "Failed to change project hours settings."
          this.$logger.error("save-hours-error", hour.id, e)
        })
    },
    deleteHour(id) {
      this.changeFailureMsg = {}
      return actions.removeSchedulingConfHour(id).catch(e => {
        this.changeFailureMsg[id] = "Failed to delete project hours settings."
        this.$logger.error("delete-hour-error", id, e)
      })
    },
    swapHours(hourA, hourB) {
      this.changeFailureMsg = {}
      this.changeSuccessMsg = {}
      Promise.all([
        actions.saveSchedulingConfHour({ ...hourA, order: hourB.order }),
        actions.saveSchedulingConfHour({ ...hourB, order: hourA.order })
      ]).catch(e => {
        this.changeFailureMsg[hourA.id] =
          "Failed to change project hours settings."
        this.$logger.error("swap-hours-error", hourA.id, hourB.id, e)
      })
    }
  }
}
</script>

<style>
.hours-table table {
  width: 100%;
  max-width: 30rem;
}
</style>
